export var ApprovalTabs;
(function (ApprovalTabs) {
    ApprovalTabs["Approvers"] = "APPROVERS";
    ApprovalTabs["Activity"] = "ACTIVITY";
})(ApprovalTabs || (ApprovalTabs = {}));
